/**
 * Kunddata i den form Flatbox-konfiguratorns offertformulär tar emot.
 * Ren logik utan importer – används av CopyCustomerDataDialog och av
 * konfiguratorn när en ny offert skapas från ett lead (/flatbox?lead=…).
 */

function formatOrgNumber(val) {
  if (!val) return '';
  const digits = val.replace(/\D/g, '');
  if (digits.length === 10) return digits.slice(0, 6) + '-' + digits.slice(6);
  return val;
}

function addressOf(company) {
  const postal = [company?.address, company?.zip, company?.city].filter(Boolean);
  if (postal.length) return postal.join(', ');
  return [company?.visitStreet, company?.visitZip, company?.visitCity].filter(Boolean).join(', ');
}

export function buildCustomerData(company, contact) {
  return {
    kund:        company?.name || '',
    kundOrgNr:   formatOrgNumber(company?.orgNumber),
    kundAdress:  addressOf(company),
    kundKontakt: contact?.name || '',
    kundEpost:   contact?.email || '',
    kundTelefon: contact?.phone || company?.phone || '',
  };
}
